import request from '@/utils/request'
import queryString from 'querystring'
// 获取登录验证码
export function captcha(data) {
    return request({
        url: '/api/send/captcha',
        method: 'post',
        data:queryString.stringify(data)
    })
}
// 登录
export function loginIn(data) {
    return request({
        url: '/login',
        method: 'post',
        data: data
    })
}

// 获取认证信息
// export function getAuthInfo() {
//     return request({
//         url: '/client/mine/auth/info',
//         method: 'post',
//     })
// }
// 注册
export function register(data) {
    return request({
        url: '/api/register',
        method: 'post',
        data: queryString.stringify(data)
    })
}
// 获取数据字典
export function getDict(key) {
    return request({
        url: '/client/api/dict/options',
        method: 'get',
        params: { key }
    })
}

//上传图片
export function upload(data) {
    return request({
        url: '/upload/upload/url',
        method: 'post',
        data: data
    })
}
// 提交认证
export function authSubmit(data) {
    return request({
        url: '/client/user/auth',
        method: 'post',
        data: queryString.stringify(data)
    })
}
// 忘记密码提交
export function forget(data) {
    return request({
        url: '/api/back/psw',
        method: 'post',
        data: queryString.stringify(data)
    })
}
//上传图片
export function uploadFile(data) {
    return request({
        url: '/client/api/upload/info',
        method: 'post',
        data: data
    })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get',
    timeout: 20000
  })
}